import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import { Grid, Row, Col, Panel, Button, Table, Breadcrumb, ButtonToolbar } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import PurchaseQuoteModal from '../../containers/Purchase/purchaseQuoteModal'

class PurchaseQuoteList extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight-UI_HEIGHT.twoLineButton,

            createOpen: false,

            rows: [],
            selectedRows: null,
            filters: {},
            sortColumn: null,
            sortDirection: null,
            purchaseQuoteDetail: {
              rows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);
        this.openCreate = this.openCreate.bind(this);
        this.closeCreate = this.closeCreate.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchPurchaseQuotes();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if (nextProps.purchaseQuotes[0] && nextProps.purchaseQuotes != this.props.purchaseQuotes) {
            let newRows = [...nextProps.purchaseQuotes];
            this.setState({
                rows: newRows
            });
        }

        if (nextProps.purchaseOrderList && nextProps.purchaseOrderList != this.props.purchaseOrderList) {
            var purchaseQuoteDetail = {...this.state.purchaseQuoteDetail, rows: nextProps.purchaseOrderList };
            this.setState({purchaseQuoteDetail});
        }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight-UI_HEIGHT.twoLineButton});
    }

    openCreate() { this.setState({ createOpen: true }); }
    closeCreate() { this.setState({ createOpen: false }); }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentPurchaseQuote(e) {
        e.preventDefault();
        const currentPurchaseQuote = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseQuote();
        this.props.selectPurchaseQuote(currentPurchaseQuote);
        this.context.router.push('/purchaseQuote/' + currentPurchaseQuote.PurchaseOrder_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseQuote();
        this.context.router.push('/purchaseQuote/new')
    }

    deletePurchaseQuote(e) {
      e.preventDefault();
      const currentPurchaseQuote = this.state.selectedRows[0];
      this.props.deletePurchaseQuote(currentPurchaseQuote.PurchaseOrder_id);
    }
    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 900) ? 345 : 345;

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            const onRowClick = (rowIdx, row) => {
              if(rowIdx != -1) {
                let rows = getRows();
                rows.map(row => {
                  row.isSelected = false;
                });
                rows[rowIdx].isSelected = true;
                this.setState({rows, selectedRows: [rows[rowIdx]]})
                this.props.fetchPurchaseOrderList(row.PurchaseOrder_id);
              }
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            const onClearFilters = () => {
               //all filters removed
               this.setState({ filters: {} });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const onRowsSelected = (rows) => {
                let newRows = getRows();
                let selectedRows = [newRows[rows[0].rowIdx]];
                newRows.map(r => {
                  r.isSelected = false;
                });
                rows.map(r => {
                  newRows[r.rowIdx].isSelected = true;
                });
                this.setState({ rows: newRows, selectedRows: selectedRows });
            }
            const onRowsDeselected = (rows) => {
                let rowIndexes = rows.map(r => r.rowIdx);
                let newRows = [...this.state.rows];
                rows.map (r => {
                  newRows[r.rowIdx].isSelected = false;
                });
                this.setState({ rows: newRows, selectedRows: [] });
            }

            // Column difinition

            const columns = [
              {
                  key: 'PONum',
                  name: <Translate value="po_num" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'VendorNum',
                  name: <Translate value="vendor_no" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'VendorName',
                  name: <Translate value="vendor_name" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
                {
                    key: 'FinalPrice',
                    name: <Translate value="final_dollarsign" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                    filterable: true
                },
                {
                    key: 'OrderDate',
                    name: <Translate value="order_date" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true,
                    formatter: DateFormatter
                },
                {
                    key: 'ETADate',
                    name: <Translate value="eta_date" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true,
                    formatter: DateFormatter
                },
                {
                    key: 'ShippingCost',
                    name: <Translate value="shipping_cost" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true
                },
                {
                    key: 'MiscCost',
                    name: <Translate value="misc_cost" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                    filterable: true
                },
                {
                    key: 'ShipTo',
                    name: <Translate value="shipto" />,
                    resizable: true,
                    sortable: true,
                    width: 75,
                    filterable: true
                },
                {
                  key: 'PurchaseStatus',
                  name: <Translate value="status" />,
                  resizable: true,
                  sortable: true,
                  width: 65,
                  filterable: true
                },
                {
                    key: 'UpdateTime',
                    name: <Translate value="update_time" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true,
                    formatter: DateFormatter
                }
            ]

            return (
                <Row><Col sm={ 12 }><div id="PurchaseQuoteList-dataGrid1">
                    <ReactDataGrid
                        rowKey='PurchaseOrder_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        onClearFilters={onClearFilters}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={tableHeight}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        rowSelection={{
                          showCheckbox: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                            isSelectedKey: 'isSelected'
                          }
                        }}
                        onRowClick={onRowClick}
                          />
                </div></Col></Row>
            )
        }
    }

    renderProductsTable() {
        if (this.props.purchaseOrderListIsLoading && !this.props.purchaseOrderListError) return <Spinner/>
        else if (this.props.purchaseOrderListError) return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.purchaseOrderListError)}
            </div>
          </ContentWrapper>)
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 900) ? 225 : 225;

            const getRows = () => {
                return Data.Selectors.getRows(this.state.purchaseQuoteDetail);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state.purchaseQuoteDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({purchaseQuoteDetail: state});
            }

            const onClearFilters = () => {
                     //all filters removed
                     let purchaseQuoteDetail = {...this.state.purchaseQuoteDetail, filters: {}};
                     this.setState({ purchaseQuoteDetail });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.purchaseQuoteDetail.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                var purchaseQuoteDetail = {...this.state.purchaseQuoteDetail, filters: newFilters};
                this.setState({ purchaseQuoteDetail });
            }



            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });


            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column definition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                },
                {
                    key: 'Name',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                },
                {
                    key: 'Description',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                },
                {
                    key: 'Quantity',
                    name: <Translate value="qty" />,
                    resizable: true,
                    width: 40,
                    sortable: true,
                },
                {
                    key: 'PackageType',
                    name: <Translate value="pkg_type" />,
                    resizable: true,
                    width: 80,
                    sortable: true,
                },
                {
                    key: 'FOBUnitPrice',
                    name: <Translate value="unit_dollarsign" />,
                    resizable: true,
                    width: 70,
                    sortable: true,
                },
                {
                    key: 'TotalPrice',
                    name: <Translate value="total_dollarsign" />,
                    resizable: true,
                    width: 80,
                    sortable: true,
                }
            ]

            // React Table Purchase Quote Table
            return (
              <Row>
                <Col xs={ 12 }>
                  <div className="recat-customizer" id="PurchaseQuoteList-dataGrid2">
                    <ReactDataGrid
                        rowKey='SalesOrder_id' //Should be PO ID???
                        onGridSort={handleGridSort}
                        onAddFilter={handleFilterChange}
                        onClearFilters={onClearFilters}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={tableHeight}
                        onRowUpdated={this.handleRowUpdated}
                      />
                  </div>
                </Col>
              </Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const createAPurchaseQuote = (<Translate value="create_a_purchase_quote" />);
        let createDialogStyle = {
            width: '400px',
            marginLeft: '-10%',
        };
        let height = (this.state.tableHeight*2/3 + 70).toString();
        let tableCollapseFix = {height: height}
        let detailsTableHeight = (this.state.tableHeight/2.5+45).toString();
        let detailsTableCollapseFix = {height: detailsTableHeight}
        return (
            //---------------
            // Begin HTML
            //---------------
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="purchase_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="purchase_quote" />
                </Breadcrumb.Item>
              </Breadcrumb>
              <Grid id="purchase-quote-list">
                <h1><Translate value="purchase_quote_full_table" /></h1>
                  <Row>
                    <Col xs={ 12 }>
                      <Panel className="position-relative table-collapse-fix">
                        <ButtonToolbar className="table-buttons">
                          <Button
                            bsStyle="success"
                            type="submit"
                            onClick={this.openCreate}
                            disabled={this.checkPermission("add_purchase_order")}>
                            <em className="fa fa-plus" />
                            <Translate value="create" />
                          </Button>
                          <Button
                            bsStyle="warning"
                            type="button"
                            onClick={(event) => { this.setCurrentPurchaseQuote(event) } }
                            disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
                            <em className="fa fa-pencil" />
                            <Translate value="edit" />
                          </Button>
                          <Button
                            bsStyle="danger"
                            type="reset"
                            onClick={(event) => { this.deletePurchaseQuote(event) } }
                            disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
                            <em className="fa fa-trash-o" /><Translate value="delete" />
                          </Button>
                        </ButtonToolbar>
                          {this.renderTable() }
                      </Panel>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={ 12 }>
                      <h2><Translate value="purchase_quote_details" /></h2>
                      <Panel className="details-table-collapse-fix">
                        {this.renderProductsTable() }
                      </Panel>
                    </Col>
                  </Row>


              </Grid>
                <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.createOpen} onCloseClicked={() => { this.closeCreate() } } title={createAPurchaseQuote}>
                    <PurchaseQuoteModal closeC={this.closeCreate} />
                </SkyLightStateless>
            </ContentWrapper>
            //---------------
            // End HTML
            //---------------
        );
    }
}



export default PurchaseQuoteList;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseQuoteList.jsx